<template>
  <div style="padding: 0px 30px">
    <h1>Join Us To Make an Impact</h1>
    <p>
      We groom students to make a change. We teach our students some of the most
      relevant topics to make them well rounded and well versed in what is going
      on. We hope they take what they learn and go ahead and make change in the
      world.
    </p>
    <img src="@/assets/wordCloud.png" width="30%" />
    <h4>Add to the Word Cloud!</h4>
    <el-form ref="form" :inline="true" :model="form" label-width="220px">
      <el-form-item label="What are you passionate about?">
        <el-input v-model="form.res" type="textarea"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">Submit</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        res: "",
      },
    };
  },
  methods: {
    onSubmit() {
      console.log("submit!");
    },
  },
};
</script>

<style scoped></style>
